exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-header{padding-top:350px;padding-bottom:50px;z-index:1000}@media (max-width:1440px){.page-header{padding-top:280px}}@media (max-width:991px){.page-header{padding-top:200px}}@media (max-width:768px){.page-header{padding-top:200px;padding-bottom:50px}}@media (max-width:576px){.page-header{padding-top:180px}}.page-header .top-banner-wrap{text-align:center}.page-header .top-banner-wrap img{width:90%;max-width:700px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3359e3de","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/PageHeader.vue
// module id = 121
// module chunks = 0